exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading svg {\n  width: 40px;\n  height: 40px;\n}\n.loading path {\n  fill: config(\"colors.blue-500\");\n}", ""]);

// exports
